const defaultState = null;

export const SET_USER_EXTERNAL_WALLETS = 'SET_USER_EXTERNAL_WALLETS';

export const userExternalWalletsReducer = (state = defaultState, action: any) => {
  const { type, data, error } = action;
  if (type === SET_USER_EXTERNAL_WALLETS) {
    if (error) return { error };
    if (data) return data;
  }
  return state;
};
